/* import __COLOCATED_TEMPLATE__ from './preview.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable @qonto/requires-task-function-syntax */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
const IS_IMAGE = /^image/;
const IS_PDF = /pdf/;
import PopupDestructive from '@qonto/ui-kit/components/popup/destructive';
let FullscreenPreviewComponent = (_class = class FullscreenPreviewComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "modals", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
  }
  get isImagePreview() {
    return IS_IMAGE.test(this.args.data.fileContentType);
  }
  get isPdfPreview() {
    return IS_PDF.test(this.args.data.fileContentType);
  }
  *confirmDeleteTask() {
    let {
      confirmDeleteTitle,
      confirmDeleteDescription,
      confirmDelete,
      cancelDelete
    } = this.args.data;
    yield this.modals.open(PopupDestructive, {
      title: confirmDeleteTitle || this.intl.t('ui-kit.fullscreen.preview.delete-file.title'),
      description: confirmDeleteDescription || this.intl.t('ui-kit.fullscreen.preview.delete-file.description'),
      confirm: confirmDelete || this.intl.t('ui-kit.fullscreen.preview.delete-file.button-confirm'),
      cancel: cancelDelete || this.intl.t('ui-kit.fullscreen.preview.delete-file.button-cancel'),
      confirmTask: this.handleDeleteTask
    });
  }
  *handleDeleteTask(close) {
    let {
      deleteTask,
      ...data
    } = this.args.data;

    // We pass a close function that closes both the Popup::Destructive
    // as well as the Fullscreen::Preview modal.
    let closeBoth = result => {
      close?.();
      this.args.close?.(result);
    };
    yield deleteTask.linked().perform(closeBoth, data);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "modals", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "confirmDeleteTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "confirmDeleteTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDeleteTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "handleDeleteTask"), _class.prototype), _class);
export { FullscreenPreviewComponent as default };